<template lang="pug">
#downline-turnover.tab-pane.fade.show.active
  .downline-wrapper.d-flex.justify-content-between
    .downline-left.border-end-0.text-left
      .row
        .col-7.text-capitalize {{$t('ui.total_downline')}}
        .col-auto.px-0 :
        //- .col-5(@click="getRefereeList") {{totalDownline}}
        .col-4 {{totalDownline}}
      .row
        .col-7.text-capitalize {{ $t('ui.rebate_toclaim') }}
        .col-auto.px-0 :
        .col-4(v-if="rebateAmount > 0") {{$store.getters.currencyCode}} {{rebateAmount}}
        .col-4(v-else) {{$store.getters.currencyCode}} {{rebateAmount}}
      .row
        .col-7.text-capitalize {{ $t('ui.rebate_total') }}
        .col-auto.px-0 :
        .col-4(v-if="totalRebateDownline > 0") {{$store.getters.currencyCode}} {{totalRebateDownline}}
        .col-4(v-else) {{$store.getters.currencyCode}} {{totalRebateDownline}}
    .downline-right.d-flex.align-items-center
      .referral-redeem.mb-0
        a(href='javascript:void(0)')
          .btn-sub.text-uppercase.p-2(:class="{'disabled-grey' : rebateAmount === 0}" @click="claimRebate") {{$t('ui.redeem')}}
  .statement-wrapper
    template(v-if="showMemberTurnover")
      .statement-mobile
        .statement-single
          template(v-if="turnoverProvider.length > 0")
            .statement-single-content(v-for="data in turnoverProvider")        
              .statement-date.redeem
                .text-capitalize {{$t('ui.provider')}}
                div {{data.provider_name}}({{data.provider_code}})
              .statement-detail
                .statement-detail-left {{$t('ui.turnover')}}
                .statement-detail-right
                  span.text-green.fw-bold {{data.turnover}}
          template(v-else)
            .text-center.my-2 {{ $t('ui.no_record') }}
      .statement-desktop
        .table-statement
          .row.table-statement-row
            .col.table-statement-col {{$t('ui.provider')}}
            .col.table-statement-col.text-end {{$t('ui.turnover')}}
          template(v-if="turnoverProvider.length > 0")
            .row.table-statement-row(v-for="data in turnoverProvider")
              .col.table-statement-col {{data.provider_name}}
              .col.table-statement-col.text-end
                span.text-green.fw-bold {{data.turnover}}
          template(v-else)
            .text-center.my-2 {{ $t('ui.no_record') }}
    template(v-else)
      .statement-mobile
        template(v-if="downlineList.length > 0")
          .statement-single(v-for="(data, index) in downlineList")
            .statement-single-content
              .statement-date No: {{index+1}}
              .statement-detail
                .statement-detail-left {{ $t('ui.username') }}
                .statement-detail-right.no-uppercase {{data.account_id}}
              .statement-detail
                .statement-detail-left {{$t('ui.turnover_amount')}}
                .statement-detail-right
                  span.text-green.fw-bold(@click="getTurnoverProvider(data.account_id)") {{data.turnover}}
                    i.fa-solid.fa-circle-chevron-right.ms-1
          .row.pagenumber.my-4
            paginate(
              v-if="!noHistory"
              :click-handler="changePage"
              :pageCount="pageCount"
              :page-range="4"
              :margin-pages="3"
              :prev-text="''"
              :next-text="''"
              :container-class="'p-0 middle'"
              :page-class="'round'"
              :page-link-class="''"
              :prev-class="'round prev'"
              :next-class="'round next'"
              :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
              :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
        template(v-else)
          .text-center.my-2 {{ $t('ui.no_record') }}
      .statement-desktop
        .table-statement
          .row.table-statement-row
            .col.table-statement-col no
            .col.table-statement-col {{$t('ui.username')}}
            .col.table-statement-col.text-end {{$t('ui.turnover_amount')}}
          template(v-if="downlineList.length > 0")
            .row.table-statement-row(v-for="(data, index) in downlineList")
              .col.table-statement-col {{index+1}}
              .col.table-statement-col.no-uppercase {{data.account_id}}
              .col.table-statement-col.text-end
                span.text-green.fw-bold.pointer(@click="getTurnoverProvider(data.account_id)") {{data.turnover}}
            .row.pagenumber.my-4
              paginate(
                v-if="!noHistory"
                :click-handler="changePage"
                :pageCount="pageCount"
                :page-range="4"
                :margin-pages="3"
                :prev-text="''"
                :next-text="''"
                :container-class="'p-0 middle'"
                :page-class="'round'"
                :page-link-class="''"
                :prev-class="'round prev'"
                :next-class="'round next'"
                :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
                :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
          template(v-else)
            .text-center.my-2 {{ $t('ui.no_record') }}
</template>
<script>
import Paginate from "vuejs-paginate";
export default {
  components: {
    Paginate
  },
  data() {
    return {
      rebateAmount: 0,
      totalRebateDownline: 0,
      totalDownline: 0,
      // workingDate: "",
      currentPage: 1,
      feedback: {
        status: "",
        success: ""
      },
      pageSize: 10,
      turnoverDownline: [],
      showMemberTurnover: false,
      turnoverProvider: []
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    downlineList(){
      return this.$store.getters.downlineList.data
    },
    workingDate() {
      return this.$store.getters.downlineList.working_date
    },
    noHistory(){
      if(this.downlineList.length > 0){
        return false
      }else{
        return true
      }
    },
    pageCount() {
      if (!this.noHistory) {
        var page = this.downlineList[0].totalrows / 10;
        if (page % 1 != 0) {
          page = page + 1;
        }
        return Math.floor(page);
      } else {
        return 0;
      }
    }
  },
  mounted(){
    this.getRebateDownline()
    this.getTurnoverDownline(this.$moment().startOf('month').format("YYYY-MM-DD"), this.pageSize, 1)
  },
  methods:{
    getRebateDownline(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getRebateDownline", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.rebateAmount = response.data[0].available_rebate_downline
              this.totalDownline = response.data[0].total_downline
              this.totalRebateDownline = response.data[0].total_rebate_downline
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    changePage(e) {
      this.currentPage = e;
      this.getTurnoverDownline(this.workingDate, this.pageSize, e);
    },
    getTurnoverDownline(workingDate, pageSize, pageNumber){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let working_month = workingDate
        let page_number = pageNumber
        let page_size = pageSize
        this.$store
          .dispatch("user/getTurnoverDownline", { account_id, auth_token, working_month, page_number, page_size })
          .then(response => {
            if (response.success == true) {
              // this.turnoverDownline = response.data
              this.$store
                .dispatch("user/sDownlineList", {data: response.data, size: 10, index: 1, working_date: working_month})
                .then(() => {
                  // this.showDetails = true
                  // this.category = 2
                  // this.$emit("reportSelected", this.category)
                })
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }      
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getTurnoverProvider(acc){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let search_id = acc
        let working_month = this.$moment().startOf('month').format("YYYY-MM-DD")
        this.$store
          .dispatch("user/getTurnoverProvider", { account_id, auth_token, working_month, search_id })
          .then(response => {
            if (response.success == true) {
              this.turnoverProvider = response.data
              this.showMemberTurnover = true
              this.$emit("showDownlineTurnover", this.accountID)
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    claimRebate(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let amount = this.rebateAmount
        this.$store
          .dispatch("user/claimRebateDownline", { account_id, auth_token, amount })
          .then(response => {
            if (response.success == true) {
              this.$helpers.showDialog(this.$t('ui.success'), "", "success", this);
              this.getRebateDownline()
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    hideDownline(){
      this.showMemberTurnover = false
    },
  }
}
</script>
<style lang="scss" scoped>
.middle{
  margin: 0 auto;
}
</style>